import React from 'react';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class ContinueButton extends React.Component{
    render(){
        return(
            <button className="App-button" onClick={this.props.onClick}>
                Weiter
            </button>
        )};
}